import React from "react";
import { motion } from "framer-motion";
import { AppWrap } from "../../wrapper";

import { images } from "../../constants";
import "./About.scss";

const abouts = [
  {
    title: "Frontend Web Developer",
    description:
      "I know HTML, CSS, JavaScript, React, Redux, Saas frontend technology",
    imgUrl: images.about02,
  },
  {
    title: "Backend Web Development",
    description: "Learning",
    imgUrl: images.about03,
  },
  {
    title: "User Experience (UX)",
    description:
      "I am good at research. I conducted research for my portfolio projects",
    imgUrl: images.about04,
  },
  {
    title: "User Interface (UI)",
    description:
      "I am a good designer. I can create wireframes, prototypes for a websites",
    imgUrl: images.about01,
  },
];

const About = () => {
  return (
    <>
      <h2 className="head-text" style={{ zIndex: 2 }}>
        I Know That <span>Good Development </span>
        <br />
        means <span>Good Business</span>
      </h2>

      <div className="list-container">
        <div className="list-img">
          <img src={images.profile} alt="" />
        </div>
        <div className="list-hobby">
          <div>🏠 I live in Etawah, Uttar Pradesh IN</div>
          <div>👨‍👩‍👧‍👦 I belong to joint family.</div>
          <div>
            🎶 I love reading editorial and watching content about geopolitical
            events.
          </div>
          <div>
            😎 When I'm free, i like to explore startups, watch ted talks, I
            like to connect with good vibing people.
          </div>
          <div>
            😊 I love to Listening to music and watching technology news.
          </div>
        </div>
      </div>

      {/* <div className="app__profiles" style={{ zIndex: 2 }}>
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={about.imgUrl} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>
              {about.title}
            </h2>
            <p className="p-text" style={{ marginTop: 10 }}>
              {about.description}
            </p>
          </motion.div>
        ))}
      </div> */}
    </>
  );
};

export default AppWrap(About, "about");
